import { Context, Emitter, Tag } from '..'

export default class extends Tag {
  render (ctx: Context, emitter: Emitter) {
    emitter['break'] = true
  }
}
